import { t } from 'i18next'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from 'src/components/Core/Iconography/Icon/Icon'
import Font from 'src/components/Core/Typography/Font/Font'
import Flex from 'src/components/Layout/Flex/Flex'
import updateModal from 'src/components/Sections/Modal/updateModal'
import Button from '../Button/Button'

export type ErrorForModalProps = {
  response?: Response;
  redirect?: boolean;
  ws?: string;
}

const ErrorForModal: FC<ErrorForModalProps> = ({ response, redirect, ws }) => {
  const navigate = useNavigate()

  return (
    <Flex flexDirection='column' maxWidth>
      <Icon name='warning' color='warning' size='xxl' />
      <Font tag='h3' margin='16px 0 0 0'>{t('error.anErrorHasOcurred')}.</Font>
      {
        ws
          ? ws
          : response?.headers?.get?.('X-Error') &&
        <Font margin='8px 0 0 0'>{t('error.error')}: {response?.headers?.get?.('X-Error')}</Font>
      }
      <Font margin='32px 0 0 0'>{t('error.clientPortalGeneralError')}</Font>
      <Font margin='8px 0 0 0'>{t('error.email')}: <strong>CRM@sucfin.com</strong></Font>
      <Font margin='8px 0 64px 0'>{t('error.phone')}: <strong>+44 (0) 20 3207 5310</strong></Font>
      {/* {'\n'}Request status: {response.status}
                {'\n'}Request status text: {response.statusText} */}
      <Button
        version={2}
        label='Close'
        onClick={() => {
          redirect && navigate('/home')
          updateModal({ modalState: 'close' })
        }}
      />
    </Flex>
  )
}

export default ErrorForModal
